export const initToggleContent = () => {
  const toggle = document.querySelectorAll('.et_pb_section .et_pb_toggle');
  const faqToggle = document.querySelectorAll('.et_pb_section .et_pb_toggle');

  const toggleTitle = document.querySelectorAll(
    '.et_pb_section .et_pb_toggle_title',
  );

  const toggleTitleFaq = document.querySelectorAll(
    '.et_pb_section .et_pb_toggle_title',
  );

  for (let i = 0; i < toggle.length; i++) {
    toggle[i].addEventListener('click', () => {
      if (toggleTitle[i]) {
        toggleTitle[i].classList.toggle('arrow-rotate');
      }
    });
  }

  for (let i = 0; i < faqToggle.length; i++) {
    faqToggle[i].addEventListener('click', () => {
      if (toggleTitleFaq[i]) {
        toggleTitleFaq[i].classList.toggle('faq-arrow-rotate');
      }
    });
  }
};
